import React from 'react';
import {StyleSheet} from 'react-native';

import AppText from '../AppText';

function ErrorMessage({error, visible, login = false}) {
  if (!visible || !error) return null;

  return (
    <AppText
      color="transparent"
      style={styles.error}
      textColor={login ? 'white' : 'red'}>
      {error}
    </AppText>
  );
}

const styles = StyleSheet.create({
  error: {
    // color: 'red',
    // fontWeight: "500",
    marginLeft: 20,
    // alignSelf: "center",
  },
});

export default ErrorMessage;
